import {useEffect, useState} from "react";
import type { ContextProps } from '../../../types';
import {PageTitle} from "../../../Components/Landmarks";
import {loanLibraryPackingListModel} from "./loanLibraryPackingListFactory";
import {isObjectNullOrEmpty} from "../../../Utilities/Types/objectUtilities";
import {loanLibraryPackingListApi} from "./loanLibraryPackingListApi";
import {PackingListFooterView} from "../PackingListFooterView";
import {PackingListHeaderView} from "../PackingListHeaderView";
import type {LoanLibraryPackingList} from "../packingList.types";

export const LoanLibraryPackingListContainer = ({
                                                    handleApiCall,
                                                    loanLibraryLoanId,
                                                }: ContextProps) => {
    const [loanLibraryPackingList, setLoanLibraryPackingList] = useState<LoanLibraryPackingList | null>(null);

    const updatePackingList = (result: Record<string, unknown>) => {
        setLoanLibraryPackingList(loanLibraryPackingListModel(result));
    }

    const handleGetLoanLibraryPackingList = () => {
        handleApiCall(() => loanLibraryPackingListApi.getLoanLibraryLoanItem(loanLibraryLoanId), updatePackingList);
    }


    useEffect(() => {
        if (loanLibraryLoanId)
            handleGetLoanLibraryPackingList();
    }, []);

    if (!loanLibraryPackingList) return null;

    return <>
        <PackingListHeaderView shipAddress={loanLibraryPackingList.shipAddressFormatted}/>

        <div className={`packingList`}>

            <hr/>

            <PageTitle h1={`Packing List`}/>

            <p>Ship Date: {loanLibraryPackingList.shipDate}</p>

            <p className={`text-center`}><b>The following item is contained in _______________ packages.</b></p>

            <div>Order Date: {loanLibraryPackingList.dateCreatedFormatted}</div>
            <div>Product Name: {loanLibraryPackingList.loanLibraryCatalogItem?.productName}</div>
        </div>

        <PackingListFooterView/>

    </>;
};
